import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const PrivacyPolicy: React.FC = () => (
  <PolicyPage slug="privacy-policy" subtitle="Privacy Policy" />
);

export default PrivacyPolicy;
